import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import Grid from '@mui/material/Grid';
import { autobind } from 'core-decorators';
import { Component } from 'react';
import PopupMap from '/@/components/ask-an-expert/popup-map';
import IconTitleText from '/@/components/crop-monitoring/icon-title-text';
import Map from '/@/components/map';
import { convertCountryBoundsToGoogleLatLng } from '/@/views/fields/field-new-v2/utils';

@autobind
export default class FieldCard extends Component {
    state = {
        expand: false,
    };

    componentDidMount() {
        if (this.props.field && this.map) {
            setTimeout(() => {
                if (this.map && this.props?.field?.geometry)
                    this.map.fitPoints(this.props.field.geometry, undefined, false);
            }, 100);
        }
    }

    focusMap() {
        if (!this.map) return;
        const googleBounds = convertCountryBoundsToGoogleLatLng(this.props.country.bounds);
        this.map.fitBounds(googleBounds);
    }

    setMapRef(ref) {
        this.map = ref;
        this.focusMap();
    }

    render() {
        return (
            <Grid
                container
                justifyContent={!this.props.isMobile ? 'flex start' : 'center'}
                sx={{
                    boxShadow: { md: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px' },
                    borderRadius: 4,
                    padding: 3,
                    paddingBottom: 0,
                }}
            >
                <Grid item xs={12} sx={{ pb: { sm: 4, md: 0 } }}>
                    <IconTitleText icon={<LocationOnOutlinedIcon sx={{ fontSize: 24 }} />} title={'Ubicación'} card />
                </Grid>
                <Grid
                    item
                    sx={{
                        height: '350px',
                        width: '100%',
                        my: 2,
                        borderRadius: 4,
                        position: 'relative',
                        mt: { xs: 4, md: 2 },
                    }}
                >
                    <Map
                        ref={this.setMapRef}
                        country={this.props.country}
                        fields={this.props.fields || []}
                        onClick={() => {}}
                        noGeocoder
                        expand={() => this.setState({ expand: true })}
                        zoomControls={false}
                        radius
                    />
                </Grid>
                <PopupMap
                    visible={this.state.expand}
                    onClose={() => this.setState({ expand: false })}
                    fields={[this.props.field]}
                    zoomPosition='BOTTOM_RIGHT'
                    country={this.props.country}
                    field={this.props.field}
                />
            </Grid>
        );
    }
}
